import type { DownloadLinkProps } from '../../../components/DownloadLink/types/propsTypes';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
const transformDownloadLink = (data: CMSTransformerDataType): DownloadLinkProps => {
  const downloadLink = Array.isArray(data.download_links) ? data.download_links[0] : data.download_links;
  const downloadLinkData = downloadLink.items.map((item: CMSTransformerDataType) => ({
    label: item.link.text,
    url: item.link.url,
    target: item.link.target,
  }));
  return {
    componentType: ComponentType.download_links,
    data: downloadLinkData,
  };
};

export default transformDownloadLink;
